import Authorize from './authorize'
export default Authorize
